/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D selection dropdown
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function SelectionButton({
    id,
    disabled = false,
    fontColor = "#c6c6c6",
    width,
    height,
    current,
    setCurrent,
    choices,
    backgroundColor = "#363636",
    hoverColor = "#474747",
    textSize = "h5",
    textSizeDecimal,
    selectedColor = "#404040",
    aframeClasses,
    ...otherAttributes
}) {
    const [isOpen, setIsOpen] = useState(false);

    const drawChoices = () => {
        return choices.map((x, i) => {
            return (
                <a-plane
                    key={i}
                    class={aframeClasses}
                    position={`0 ${(i + 1) * -height} ${width / 100}`}
                    width={width}
                    height={height}
                    color={x === current ? selectedColor : backgroundColor}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCurrent(x);
                        setIsOpen(false);
                    }}
                    animation__mouseenter_color={`property: color; startEvents: mouseenter; to: ${hoverColor}; dur:150`}
                    animation__mouseleave_color={`property: color; startEvents: mouseleave; to: ${
                        x === current ? selectedColor : backgroundColor
                    }; dur:150`}
                >
                    <Text
                        position={`${(-width / 2) * 0.9} 0 0.01`}
                        color={fontColor}
                        align="left"
                        width={width * 0.8}
                        text={x.toString()}
                        size={textSize}
                        sizeDecimal={textSizeDecimal * 1.1}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setCurrent(x);
                            setIsOpen(false);
                        }}
                    />
                </a-plane>
            );
        });
    };

    return (
        <a-entity class="SelectionButton" {...otherAttributes}>
            <a-plane
                class={aframeClasses}
                width={width}
                height={height}
                color={backgroundColor}
                opacity={disabled ? "0.5" : "1"}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (disabled) return;
                    setIsOpen((old) => !old);
                }}
            >
                <Text
                    position={`${(-width / 2) * 0.9} 0 0.01`}
                    color={fontColor}
                    align="left"
                    width={width * 0.85}
                    value={
                        current !== undefined ? current.toString() : "Select"
                    }
                    opacity={disabled ? "0.5" : "1"}
                    size={textSize}
                    sizeDecimal={textSizeDecimal}
                />
                <a-image
                    width={height * 0.6}
                    height={height * 0.6}
                    position={`${(width / 2) * 0.75} 0 0.01`}
                    src={isOpen ? "#SortingUp" : "#SortingDown"}
                />
            </a-plane>
            {isOpen && drawChoices()}
        </a-entity>
    );
}

SelectionButton.propTypes = {
    choices: PropTypes.array.isRequired,
    setCurrent: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    id: PropTypes.any.isRequired
};

export default SelectionButton;
